// Picker de packs a elección — v2 "tarjetas" (reemplazo del v1 por dropdowns).
// Casilleros numerados + grid de tarjetas por /collections/<handle>/products.json
// (oculta agotados), pregunta de edad inline cuando el producto tocado tiene más
// de una variante permitida, y escribe las properties que lee la Cart Transform
// Function: visibles ("Tu elección N") + _pack_sel (ids CSV) — mismo contrato
// exacto que el v1, la Function no cambia. El form se localiza por data-form-id
// (id real del <form>, no por selector genérico) para no enganchar el form
// incorrecto si hay más de uno en la página (ej. quick-add de un cross-sell).
// Las tarjetas se intersectan con permitidos (data-config): anti-drift si la
// colección del picker se desincroniza de la config del metafield.
(function () {
  const cache = {};

  const EDADES_AMIGABLES = {
    '6M-12M': '6 a 12 meses',
    '12M-5A': '1 a 5 años',
    '6A-11A': '6 a 11 años',
  };

  function edadLabel(tituloVariante) {
    return EDADES_AMIGABLES[tituloVariante] || tituloVariante;
  }

  function fotoChica(src, size) {
    if (!src) return null;
    const sep = src.includes('?') ? '&' : '?';
    return `${src}${sep}width=${size}&height=${size}&crop=center`;
  }

  async function productosDeColeccion(handle) {
    if (!cache[handle]) {
      const res = await fetch(`/collections/${handle}/products.json?limit=250`);
      const data = await res.json();
      cache[handle] = data.products;
    }
    return cache[handle];
  }

  function permitidosSet(config) {
    const permitidos = config && Array.isArray(config.permitidos) ? config.permitidos : [];
    return new Set(permitidos.map(Number));
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  // Cart-bump "¿Y si te llevas 6?" (Etapa C, snippets/teren-pack6-bump.liquid):
  // tras agregar el Pack 6 con las 3 elecciones arrastradas de un Pack 3, quita
  // el Pack 3 original del carrito por su `key` exacta (/cart/change.js con
  // `id: key`, ver hallazgo Fase 1 — el Pack 3 vive en el carrito como UNA sola
  // línea, sin expandir). Si falla, se loguea y quedan ambos packs — el cliente
  // puede quitar el sobrante a mano; no rompe el add que ya sucedió.
  async function swapTrasAgregar(bumpFromKey) {
    try {
      const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
      const res = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: bumpFromKey,
          quantity: 0,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const parsedState = await res.json();
      if (parsedState.status) {
        console.warn('teren-pack6-bump: no se pudo quitar el Pack 3 original tras agregar el Pack 6', parsedState);
        return;
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        bubble.innerHTML = getSectionInnerHTML(parsedState.sections['cart-icon-bubble']);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'teren-pack6-bump', cartData: parsedState });
      }
    } catch (e) {
      // degradación aceptable (spec Etapa C): quedan ambos packs en el carrito.
      console.warn('teren-pack6-bump: swap del Pack 3 original falló, quedaron ambos packs', e);
    }
  }

  function nombreParaProps(product, variant) {
    return product.variants.length > 1 ? `${product.title} — ${variant.title}` : product.title;
  }

  const PLACEHOLDERS = ['Elige tu primera mezcla', 'La segunda…', 'Y la tercera'];
  function placeholder(i) {
    return PLACEHOLDERS[i] || `Mezcla ${i + 1}`;
  }

  async function init(picker) {
    const form = document.getElementById(picker.dataset.formId);
    if (!form) return;

    let config;
    try {
      config = JSON.parse(picker.dataset.config || 'null');
    } catch {
      config = null;
    }
    if (!config || !Array.isArray(config.slots) || !config.slots.length) return;

    const submits = form.querySelectorAll('[type="submit"], button[name="add"]');
    const hint = picker.querySelector('[data-hint]');
    const casilleros = Array.from(picker.querySelectorAll('[data-casilleros] [data-slot]'));
    const grid = picker.querySelector('[data-cartas]');
    const gridTitulo = picker.querySelector('[data-cartas-titulo]');
    const pregunta = picker.querySelector('[data-pregunta]');
    const peNombre = picker.querySelector('[data-pe-nombre]');
    const peBotones = picker.querySelector('[data-pe-botones]');
    const peCancelar = picker.querySelector('[data-pe-cancelar]');
    if (!casilleros.length || !grid) return;

    function setEnabled(on) {
      submits.forEach((b) => {
        b.disabled = !on;
        b.setAttribute('aria-disabled', String(!on));
      });
      if (hint) {
        hint.hidden = false;
        hint.textContent = on ? '¡Listo! Tu pack quedaría armado ✅' : 'Completa tu selección para agregar el pack 🌿';
        hint.classList.toggle('teren-pack-picker__hint--listo', on);
      }
    }
    setEnabled(false);

    const permitidos = permitidosSet(config);
    if (!permitidos.size) return;
    // permitidos vacío/ausente: fail-safe, ATC queda deshabilitado con el hint
    // visible (setEnabled(false) ya aplicado) — no hay forma segura de armar el pack.

    const beneficios = config.beneficios && typeof config.beneficios === 'object' ? config.beneficios : {};
    const colecciones = config.slots.map((s) => s.coleccion);
    const compartida = colecciones.every((c) => c === colecciones[0]);

    const pick = new Array(config.slots.length).fill(null);
    let pendiente = null;
    const catalogoPorColeccion = {};

    async function catalogo(handle) {
      if (catalogoPorColeccion[handle]) return catalogoPorColeccion[handle];
      const productos = await productosDeColeccion(handle);
      const procesados = productos
        .map((product) => ({
          product,
          elegibles: product.variants.filter((v) => v.available !== false && permitidos.has(Number(v.id))),
        }))
        .filter((x) => x.elegibles.length);
      catalogoPorColeccion[handle] = procesados;
      return procesados;
    }

    function primerVacio() {
      return pick.findIndex((p) => p === null);
    }

    function renderCasilleros() {
      casilleros.forEach((cas, idx) => {
        const p = pick[idx];
        cas.classList.toggle('teren-pack-picker__casillero--lleno', Boolean(p));
        cas.innerHTML = `<span class="teren-pack-picker__num">${idx + 1}</span>`;
        if (p) {
          const det = document.createElement('span');
          det.className = 'teren-pack-picker__det';
          det.innerHTML = `<b></b><span></span>`;
          det.querySelector('b').textContent = p.productTitle;
          det.querySelector('span').textContent = p.edadTexto || '';
          cas.appendChild(det);
          const sacar = document.createElement('button');
          sacar.type = 'button';
          sacar.className = 'teren-pack-picker__sacar';
          sacar.setAttribute('aria-label', 'Quitar');
          sacar.textContent = '✕';
          sacar.addEventListener('click', () => quitar(idx));
          cas.appendChild(sacar);
        } else {
          const vacio = document.createElement('span');
          vacio.className = 'teren-pack-picker__vacio';
          vacio.textContent = placeholder(idx);
          cas.appendChild(vacio);
        }
      });
    }

    function quitar(idx) {
      pick.splice(idx, 1);
      pick.push(null); // compacta: los posteriores suben de casillero
      renderCasilleros();
      renderGrid();
      sync();
    }

    function marcarBadges() {
      grid.querySelectorAll('[data-product-id]').forEach((el) => {
        const productId = Number(el.dataset.productId);
        const n = pick.filter((p) => p && p.productId === productId).length;
        const veces = el.querySelector('.teren-pack-picker__veces');
        el.classList.toggle('teren-pack-picker__carta--elegida', n > 0);
        if (n) {
          veces.hidden = false;
          veces.textContent = n === 1 ? '✓' : `×${n}`;
        } else {
          veces.hidden = true;
        }
      });
    }

    function crearCarta(product, elegibles) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'teren-pack-picker__carta';
      b.dataset.productId = String(product.id);

      const veces = document.createElement('span');
      veces.className = 'teren-pack-picker__veces';
      veces.hidden = true;
      b.appendChild(veces);

      const foto = document.createElement('span');
      foto.className = 'teren-pack-picker__foto';
      const img = product.images && product.images[0];
      const src = img ? fotoChica(img.src, 120) : null;
      if (src) {
        const imgEl = document.createElement('img');
        imgEl.src = src;
        imgEl.alt = '';
        imgEl.loading = 'lazy';
        imgEl.width = 60;
        imgEl.height = 60;
        foto.appendChild(imgEl);
      } else {
        const fallback = document.createElement('span');
        fallback.className = 'teren-pack-picker__foto-fallback';
        fallback.setAttribute('aria-hidden', 'true');
        foto.appendChild(fallback);
      }
      b.appendChild(foto);

      const nom = document.createElement('span');
      nom.className = 'teren-pack-picker__nom';
      nom.textContent = product.title;
      b.appendChild(nom);

      const benefTexto = beneficios[product.handle];
      if (benefTexto) {
        const ben = document.createElement('span');
        ben.className = 'teren-pack-picker__ben';
        ben.textContent = benefTexto;
        b.appendChild(ben);
      }

      b.addEventListener('click', () => tocarCarta(product, elegibles));
      return b;
    }

    async function renderGrid() {
      const idx = primerVacio();
      if (idx === -1) {
        grid.innerHTML = '';
        if (gridTitulo) gridTitulo.hidden = true;
        pregunta.hidden = true;
        pendiente = null;
        return;
      }
      const slot = config.slots[idx];
      const items = await catalogo(slot.coleccion);
      grid.innerHTML = '';
      items.forEach(({ product, elegibles }) => grid.appendChild(crearCarta(product, elegibles)));
      if (gridTitulo) {
        if (compartida) {
          gridTitulo.hidden = true;
        } else {
          gridTitulo.hidden = false;
          gridTitulo.textContent = slot.titulo;
        }
      }
      marcarBadges();
    }

    function tocarCarta(product, elegibles) {
      if (primerVacio() === -1) return;
      if (elegibles.length === 1) {
        asignar(product, elegibles[0]);
        return;
      }
      pendiente = { product, elegibles };
      peNombre.textContent = product.title;
      peBotones.innerHTML = '';
      elegibles.forEach((v) => {
        const c = document.createElement('button');
        c.type = 'button';
        c.className = 'teren-pack-picker__chip';
        c.textContent = edadLabel(v.title);
        c.addEventListener('click', () => {
          asignar(pendiente.product, v);
          pendiente = null;
          pregunta.hidden = true;
        });
        peBotones.appendChild(c);
      });
      pregunta.hidden = false;
      pregunta.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    peCancelar.addEventListener('click', () => {
      pendiente = null;
      pregunta.hidden = true;
    });

    function asignar(product, variant) {
      const idx = primerVacio();
      if (idx === -1) return;
      pick[idx] = {
        productId: product.id,
        productTitle: product.title,
        variantId: variant.id,
        edadTexto: product.variants.length > 1 ? edadLabel(variant.title) : '',
        nombre: nombreParaProps(product, variant),
      };
      renderCasilleros();
      renderGrid();
      sync();
    }

    function add(name, value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.setAttribute('data-pack-prop', '');
      form.appendChild(input);
    }

    function sync() {
      const completo = pick.every(Boolean);
      form.querySelectorAll('input[data-pack-prop]').forEach((n) => n.remove());
      if (completo) {
        pick.forEach((p, i) => add(`properties[Tu elección ${i + 1}]`, p.nombre));
        add('properties[_pack_sel]', pick.map((p) => p.variantId).join(','));
      }
      setEnabled(completo);
    }

    // Prefill (cart-bump "¿Y si te llevas 6?"): arma un mapa variantId -> {product,
    // variant} recorriendo TODAS las colecciones de los slots (no solo la del
    // primero) para no asumir "compartida", y llena los primeros casilleros
    // vacíos en el orden recibido. Los ids que no matchean ningún elegible
    // (fuera de permitidos, agotados, o basura de la URL) se ignoran solos: no
    // están en el mapa. Nunca salta el gate de completar el pack — sigue
    // siendo el mismo asignar()/sync() que usa el click manual de una tarjeta.
    async function aplicarPrefill(ids) {
      if (!ids.length || primerVacio() === -1) return;
      const colsUnicas = [...new Set(colecciones)];
      const catalogos = await Promise.all(colsUnicas.map((c) => catalogo(c)));
      const mapa = new Map();
      catalogos.forEach((items) => {
        items.forEach(({ product, elegibles }) => {
          elegibles.forEach((v) => {
            const id = Number(v.id);
            if (!mapa.has(id)) mapa.set(id, { product, variant: v });
          });
        });
      });
      ids.forEach((id) => {
        if (primerVacio() === -1) return;
        const hit = mapa.get(id);
        if (hit) asignar(hit.product, hit.variant);
      });
    }

    renderCasilleros();
    renderGrid();

    const params = new URLSearchParams(window.location.search);
    const prefillParam = params.get('prefill');
    const bumpFrom = params.get('bump_from');

    if (prefillParam) {
      const ids = prefillParam
        .split(',')
        .map((s) => Number(s.trim()))
        .filter((n) => Number.isFinite(n) && n > 0);
      if (ids.length) {
        aplicarPrefill(ids).then(() => {
          picker.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }
    }

    if (bumpFrom) {
      const formVariantInput = form.querySelector('[name="id"]');
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'product-form') return;
        if (!formVariantInput || String(event.productVariantId) !== String(formVariantInput.value)) return;
        swapTrasAgregar(bumpFrom);
      });
    }
  }

  document.querySelectorAll('.teren-pack-picker').forEach(init);
})();
